module.exports = __webpack_public_path__ + "static/RajivAgarwal-1f24c9833610dd09e64fa7d13349f73a.jpg";